import { memo } from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./app/auth";
import { AdvancedExchangeContextProvider } from "./contexts/AdvancedExchangeContext";
import { CurrentItemBeingReturnedContextProvider } from "./contexts/CurrentItemBeingReturnedContext";
import { CurrentOrderContextProvider } from "./contexts/CurrentOrderContext";
import { ExchangeTypeContextProvider } from "./contexts/ExchangeTypeContext";
import { FlowStepContextProvider } from "./contexts/FlowStepContext";
import { ItemsReadyForReturnContextProvider } from "./contexts/ItemsReadyForReturnContext";
import { UserContextProvider } from "./contexts/LoggedInUserContext";
import { ScreenTypeContextProvider } from "./contexts/ScreenTypeContext";
import { SettingsContextProvider } from "./contexts/SettingsContext";

export const Root = memo(() => {
  return (
    <SettingsContextProvider>
      <AuthProvider>
        <AdvancedExchangeContextProvider>
          <ScreenTypeContextProvider>
            <CurrentOrderContextProvider>
              <CurrentItemBeingReturnedContextProvider>
                <ItemsReadyForReturnContextProvider>
                  <UserContextProvider>
                    <ExchangeTypeContextProvider>
                      <FlowStepContextProvider>
                        <Outlet />
                      </FlowStepContextProvider>
                    </ExchangeTypeContextProvider>
                  </UserContextProvider>
                </ItemsReadyForReturnContextProvider>
              </CurrentItemBeingReturnedContextProvider>
            </CurrentOrderContextProvider>
          </ScreenTypeContextProvider>
        </AdvancedExchangeContextProvider>
      </AuthProvider>
    </SettingsContextProvider>
  );
});
